const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="presentation" aria-hidden="true"><path d="M5.75 7a.75.75 0 0 0-1.5 0v10a.75.75 0 0 0 1.5 0zM10 6.25a.75.75 0 0 1 .75.75v10a.75.75 0 0 1-1.5 0V7a.75.75 0 0 1 .75-.75m4.47.22a.75.75 0 0 1 1.06 0l4.293 4.293a1.75 1.75 0 0 1 0 2.474L15.53 17.53a.75.75 0 1 1-1.06-1.06l4.293-4.293a.25.25 0 0 0 0-.354L14.47 7.53a.75.75 0 0 1 0-1.06"/></svg>';
export {
  a as w
};
